import { FC } from 'react';
import { EquipmentModelNumber } from '../models/equipment.models';
import { Flex, Text } from '@servicetitan/anvil2';

export const ModelItem: FC<{ item: EquipmentModelNumber }> = ({ item }) => {
    return (
        <Flex direction="row" alignItems="center" gap="3">
            <Flex direction="column">
                <img
                    src={item.brandeImage}
                    style={{
                        width: 45,
                        height: 16,
                        objectFit: 'contain',
                    }}
                />
                <img
                    src={item.modelImage}
                    style={{
                        width: 48,
                        height: 48,
                        objectFit: 'contain',
                    }}
                />
            </Flex>
            <Flex direction="column">
                <Text size="medium">{item.text}</Text>
                <Text
                    size="small"
                    subdued
                    style={{
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'normal',
                    }}
                >
                    {item.notes}
                </Text>
            </Flex>
        </Flex>
    );
};
